<template>
  <header id="menu">
    <nav class="navbar navbar-expand-xl d-block">
      <a class="navbar-logo" href="/admin">
        <img src="/img/white-logo.svg" />
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#Marimanga"
        aria-controls="Marimanga"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="fa fa-bars"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-end" id="Marimanga">
        <ul class="dashboard-list" style="list-style-type:none">
          <li :class="{ active: this.$route.name === 'admin' }">
            <router-link tag="a" to="/admin">Home</router-link>
          </li>
          <div v-for="nav in navigation" :key="nav.id">
            <li
                :class="{ active: route === nav.to }" v-if="nav.role">
              <router-link tag="a" :to="`/${nav.to}`">{{ nav.name }}</router-link>
            </li>
          </div>
        </ul>
      </div>
      <div class="client-name">
        <h4 v-if="this.$store.state.account.firstName">{{ `${this.$store.state.account.firstName} ${this.$store.state.account.lastName}`}}</h4>
        <h4 v-else>{{ `${this.user().full_name}`}}</h4>
        <a href="#" @click="logout">Logout</a>
      </div>
    </nav>
  </header>
</template>
<style src="@/assets/admin/css/main.css"></style>
<script>
import { mapGetters } from "vuex";

export default {
  name: "AdminSidebar",
  beforeMount() {
    this.$store.dispatch("account/requestPersonalData", {
      route: this.$route,
      router: this.$router
    });
  },
  computed: {
      showTransportRequests() {
          if(this.user().user_type === 'superadmin' || this.user().user_type === 'operations') {
              return true;
          }
          return false;
      },
      showClients() {
          if(this.user().user_type === 'superadmin' || this.user().user_type === 'finances') {
              return true;
          }
          return false;
      },
      showAgents() {
          if(this.user().user_type === 'superadmin') {
              return true;
          }
          return false;
      },
      showFinances() {
          if(this.user().user_type === 'superadmin' || this.user().user_type === 'finances') {
              return true;
          }
          return false;
      },
      showUsers() {
          if(this.user().user_type === 'superadmin') {
              return true;
          }
          return false;
      },
    navigation() {
      return [
        {id: 1, name: 'Kerkesat per transport', to: 'admin/requests', role: this.userOfType('superadmin','operations','finops')},
        {id: 2, name: 'Menaxhimi i klienteve', to: 'admin/clients', role: this.userOfType('superadmin','finops', 'driver')},
        {id: 3, name: 'Agjentet', to: 'admin/agents', role: this.userOfType('superadmin')},
        {id: 4, name: 'Partneret', to: 'admin/partner/requests', role: this.userOfType('superadmin','finops')},
        {id: 5, name: 'Menaxhimi i Agjentëve', to: 'admin/agents/requests', role: this.userOfType('superadmin','finops')},
        {id: 6, name: 'Financat', to: 'admin/finances', role: this.userOfType('superadmin','finances','finops')},
        {id: 7, name: 'Perdoruesit', to: 'admin/users', role: this.userOfType('superadmin')},
        {id: 8, name: 'Promo Kodet', to: 'admin/promo-codes', role: this.userOfType('superadmin')},
        {id: 9, name: 'Promocionet', to: 'admin/promocionet', role: this.userOfType('superadmin')},
        {id: 10, name: 'Statistikat e klienteve', to: 'admin/statistics/clients', role: this.userOfType('superadmin')},
        {id: 11, name: "Statistikat e shofereve", to: "admin/statistics/drivers", role: this.userOfType('superadmin')},
        {id: 12, name: "Guest Interventions", to: "admin/guest/interventions", role: this.userOfType('superadmin')},
      ];
    },
    route() {
        return this.$route.name
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("login/logout", this.$router);
    }
  },
  getters: {
    ...mapGetters({
      firstName: "account/firstName",
      lastName: "account/lastName",
      userType: "account/userType"
    })
  }
};
</script>
